import {
  Button, FormControlLabel, Grid, MenuItem, Paper, Switch, TextField,
  Autocomplete
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { ValidarRut } from "../Utilities/ValidarRut";
import { useSelector, useDispatch } from "react-redux";
import { setCargaGeneral } from "../Redux/GeneralDuck";
import { setCargaDatos } from "../Redux/V2/ContratoRedux";
import {
  useJsApiLoader, Autocomplete as GoogleMapsAutocomplete,
} from "@react-google-maps/api";
import { audioService } from "../services/audioService";
import ShowInformation from "./subs/ShowInformation";
import AddIcon from '@mui/icons-material/Add';
import Swal from "sweetalert2";
import { SkipNext } from '@mui/icons-material';

const libraries = ["places"];

const Defendido = ({ from, onChangeSave }) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [bloquearAcciones, setBloquearAcciones] = useState(false);
  const [autocomplete, setAutocomplete] = useState(null);
  const [dealHubspotIds, setDealHubspotIds] = useState([]);
  const [allowUpdate, setAllowUpdate] = useState(true);

  const sucursal = useSelector((store) => store.general.sucursales);
  const genero = useSelector((store) => store.general.generos);
  const estadoCivil = useSelector((store) => store.general.estadoCivil);
  const paises = useSelector((store) => store.general.paises);
  const regiones = useSelector((store) => store.general.regiones);
  const provincias = useSelector((store) => store.general.provincias);
  const comunas = useSelector((store) => store.general.comunas);
  const defendido = useSelector((store) => store.contratoV2.Defendido);
  const entrevista = useSelector((store) => store.contratoV2.Entrevista);
  const actualizacion = useSelector((store) => store.contratoV2.Actualizacion);

  // 🔒 estados de contrato
  const contratoCancelado = useSelector((store) => store.contratoV2.ContratoCancelado);
  const contratoFiniquitado = useSelector((store) => store.contratoV2.ContratoFiniquitado);
  const contratoFirmado = useSelector((store) => store.contratoV2.ContratoFirmado);


  //const [disabledComponent, setDisabledComponent] = useState(false);

  const disabledComponent = actualizacion?.actualizacion?.status == 1

  const bloqueadoTotalmente =
    !!contratoCancelado?.cancelado ||
    !!contratoFiniquitado?.finiquitado || (contratoFirmado?.firmado && !disabledComponent)

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: window.GOOGLE_API_KEY,
    libraries,
  });

  const [errors, setErrors] = useState({
    hubspotID: false,
    identifier: false,
    firstName: false,
    lastName: false,
    email: false,
    telephone: false,
    birthDate: false,
    address: false,
    idCountry: false,
    idRegion: false,
    idProvince: false,
    idDistrito: false,
    idBranch: false,
    claveUnica: false,
    observations: false,
    idGenero: false,
    idEstadoCivil: false,
    clientType: false,
    pymeRut: false,
    pymeName: false,
    dealHubspotId: false,
  });

  const [customer, setCustomer] = useState({});

  useEffect(() => {
    if (actualizacion?.actualizacion?.status == 1) { //actualizacion en curso, cargar el defendido de la actualizacion
      if (actualizacion.actualizacionModelos && actualizacion.actualizacionModelos.length > 0) {
        const _defendidoAct = actualizacion.actualizacionModelos.find(obj => obj.model == "defendido");
        if (_defendidoAct != null) {
          setCustomer(JSON.parse(_defendidoAct.json));
          return
        }
      }
    }

    if ((defendido == null || customer.id == null) && entrevista) { //si no hay defendido cargado. si no es actualizacion en curso o no se encontro el defendido de la actualizacion, buscar el defendido de la entrevista
      dispatch(setCargaDatos("Defendido", "get", entrevista.id));
    }

  }, [defendido, entrevista, actualizacion]);

  useEffect(() => {
    if (defendido && Object.keys(customer).length === 0) {
      var aux = { ...defendido }

      if (aux.claveUnica) {
        aux.claveUnicaB = aux.claveUnica
        aux.conClaveUnica = true
      } else
        aux.conClaveUnica = true

      if (aux.idCountry == null || aux.idCountry == 0)
        aux.idCountry = 1
      setCustomer(aux);
    }
  }, [defendido]);

  useEffect(() => {
    if (actualizacion?.actualizacion?.status == 1) { //actualizacion en curso, cargar el defendido de la actualizacion
      //setDisabledComponent(true)
      if (actualizacion.actualizacionModelos && actualizacion.actualizacionModelos.length > 0) {
        const _defendidoAct = actualizacion.actualizacionModelos.find(obj => obj.model == "defendido");
        if (_defendidoAct != null) {
          setCustomer(JSON.parse(_defendidoAct.json));
          return
        }
      }
    }
  }, [entrevista]);

  useEffect(() => {
    const fetchHubspotDeals = async () => {
      if (customer.hubspotID) {
        try {
          const dataHb = await audioService.getHubspotDealsContact(
            customer.hubspotID
          );

          if (
            dataHb.associations &&
            dataHb.associations.deals &&
            dataHb.associations.deals.results &&
            dataHb.associations.deals.results.length > 0
          ) {
            const dealIds = dataHb.associations.deals.results;
            setDealHubspotIds(
              dealIds.map((item) => ({ id: item.id, name: item.id }))
            );
          } else {
            //alert("El contacto de Hubspot no tiene negocios identificados.");
            Swal.fire({
              icon: "error",
              title: "Error de Hubspot",
              text: "El contacto de Hubspot no tiene negocios identificados.",
            });
            setDealHubspotIds([]);
          }
        } catch (error) {
          console.error("Error al obtener los negocios de Hubspot:", error);
          //alert("Hubo un error al cargar los negocios de Hubspot.");
          Swal.fire({
            icon: "error",
            title: "Error de Hubspot",
            text: "Hubo un error al cargar los negocios de Hubspot.",
          });
        }
        setLoading(false);
      }
    };

    fetchHubspotDeals();
  }, [customer.hubspotID]);

  useEffect(() => {
    if (
      customer?.address &&
      customer?.idDistrito === 0 &&
      window.google &&
      isLoaded
    ) {
      const geocoder = new window.google.maps.Geocoder();

      geocoder.geocode(
        {
          address: customer.address,
          componentRestrictions: { country: "CL" },
        },
        (results, status) => {
          if (status === "OK" && results[0]) {
            processPlace(results[0]);
          }
        }
      );
    }
  }, [customer.address, isLoaded]);

  const handleChange = (e) => {
    if (bloqueadoTotalmente) return; // 🔒 no permitir cambios
    const { name, value } = e.target;
    setCustomer((prevData) => ({ ...prevData, [name]: value }));
    handleError(name, value);
    if (name === "clientType" && value === 1) {
      setCustomer((prevData) => ({
        ...prevData,
        pymeRut: "",
        pymeName: "",
      }));
      setErrors((prevData) => ({
        ...prevData,
        pymeRut: false,
        pymeName: false,
      }));
    }
  };

  const handleError = (name, value) => {
    let error = false;
    switch (name) {
      case "identifier":
        if (value && !ValidarRut(value)) error = "Rut inválido";
        break;
      case "pymeRut":
        if (customer.clientType == 2 && (!ValidarRut(value) || !value.includes("-"))) {
          error = "Rut inválido";
        }
        break;
      case "pymeName":
        if (customer.clientType === 2 && !value) error = "Nombre inválido";
        break;
      case "claveUnicaB":
        if (customer.conClaveUnica && value !== customer.claveUnica)
          error = "Las claves no coinciden";
        break;
      case "claveUnica":
        if (customer.conClaveUnica && value.length < 8)
          error = "Mínimo 8 caracteres";
        break;
      case "email":
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value && !emailRegex.test(value)) error = "Email inválido";
        break;
      case "telephone":
        const phoneRegex = /^[0-9+\s()-]+$/;
        if (value && !phoneRegex.test(value)) error = "Teléfono inválido";
        break;
      case "dealHubspotId":
        if (dealHubspotIds.length > 0 && !value)
          error = "Este campo es requerido";
        break;
      default:
        //if (!value) error = "Este campo es requerido";
        break;
    }
    setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
  };

  const handleSubmit = async (event) => {
    console.log(customer)
    event.preventDefault();
    if (bloqueadoTotalmente) { // 🔒 no permitir guardar
      //alert("No es posible editar: contrato cancelado, finiquitado o firmado.");

      Swal.fire({
        icon: "warning",
        title: "No se puede editar",
        text: "No es posible editar: contrato cancelado, finiquitado o firmado.",
      });

      return;
    }

    let newErrors = {};
    let hasError = false;

    const requiredFields = [
      "hubspotID",
      "dealHubspotId",
      "identifier",
      "firstName",
      "lastName",
      "email",
      "telephone",
      "birthDate",
      "address",
      "idCountry",
      "idRegion",
      "idProvince",
      "idDistrito",
      "idBranch",
      "idGenero",
      "idEstadoCivil",
    ];

    requiredFields.forEach((field) => {
      if (
        !customer[field] ||
        customer[field] === "" ||
        customer[field] === null
      ) {
        newErrors[field] = "Este campo es requerido.";
        hasError = true;
      }
    });

    if (customer.identifier && !ValidarRut(customer.identifier)) {
      newErrors.identifier = "Rut inválido.";
      hasError = true;
    }

    if (customer.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customer.email)) {
      newErrors.email = "Email inválido.";
      hasError = true;
    }

    if (customer.telephone && !/^[0-9+\s()-]+$/.test(customer.telephone)) {
      newErrors.telephone = "Teléfono inválido.";
      hasError = true;
    }

    if (customer.clientType === 2) {
      if (!customer.pymeRut) {
        newErrors.pymeRut = "El Rut de la empresa es requerido.";
        hasError = true;
      } else if (customer.pymeRut && !ValidarRut(customer.pymeRut)) {
        newErrors.pymeRut = "Rut de empresa inválido.";
        hasError = true;
      }
      if (!customer.pymeName) {
        newErrors.pymeName = "El nombre de la empresa es requerido.";
        hasError = true;
      }
    }

    if (customer.conClaveUnica) {
      if (!customer.claveUnica) {
        newErrors.claveUnica = "Este campo es requerido.";
        hasError = true;
      } else if (customer.claveUnica.length < 8) {
        newErrors.claveUnica = "Mínimo 8 caracteres.";
        hasError = true;
      }
      if (customer.claveUnica !== customer.claveUnicaB) {
        newErrors.claveUnicaB = "Las claves no coinciden.";
        hasError = true;
      }
    }

    if (
      dealHubspotIds.length > 0 &&
      (!customer.dealHubspotId || customer.dealHubspotId === "")
    ) {
      newErrors.dealHubspotId = "Este campo es requerido.";
      hasError = true;
    }

    setErrors(newErrors);

    if (hasError) {
      alert(
        "Por favor, corrige los errores en el formulario antes de guardar."
      );
      return;
    }

    if (bloquearAcciones) return;
    setBloquearAcciones(true);
    setTimeout(() => setBloquearAcciones(false), 3000);

    setErrors(newErrors);

    const isValid = Object.values(errors).every((err) => err === false);

    if (isValid) {
      try {
        var aux = customer;
        aux.clientId = entrevista.customerId;
        aux.interviewId = entrevista.id;

        if (actualizacion?.actualizacion?.status == 1) { //si es actualizacion en curso
          var payload = {
            json: JSON.stringify(aux),
            model: "defendido",
            actualizacionId: actualizacion.actualizacion.id,
          }
          var exito = await dispatch(setCargaDatos("Actualizacion", "put", payload));
          onChangeSave(from)
        } else {
          await dispatch(setCargaDatos("Defendido", "post", aux));
          await dispatch(setCargaDatos("Entrevista", "get", entrevista.id));
        }

        setErrors({});
        setAllowUpdate(false);
        setBloquearAcciones(true);
      } catch (error) {
        console.error("Error al guardar los datos:", error);
      }
    } else {
      alert(
        "Por favor, corrige los errores en el formulario antes de guardar."
      );
    }
  };

  function removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  function includesIgnoreAccents(str, search) {
    return removeAccents(str)
      .toLowerCase()
      .includes(removeAccents(search).toLowerCase());
  }

  const handlePlaceChanged = () => {
    if (bloqueadoTotalmente) return; // 🔒 no actualizar dirección si está bloqueadoTotalmente
    if (autocomplete) {
      const place = autocomplete.getPlace();
      processPlace(place);
    }
  };

  const processPlace = (place) => {
    const address = place.formatted_address || "";
    const addressComponents = place.address_components || [];

    let newRegionId = "";
    let newProvinciaId = "";
    let newComunaId = "";
    let newSucursalId = "";

    const regionData = addressComponents.find((comp) =>
      comp.types.includes("administrative_area_level_1")
    );

    const provinciaData = addressComponents.find((comp) =>
      comp.types.includes("administrative_area_level_2")
    );

    const comunaData = addressComponents.find((comp) =>
      comp.types.includes("locality")
    );

    if (regionData) {
      const sRegion = regiones.find((r) =>
        r.description.includes(regionData.long_name)
      );
      if (sRegion) newRegionId = sRegion.id;
    }

    if (provinciaData) {
      const sProvincia = provincias.find((p) =>
        includesIgnoreAccents(p.description, provinciaData.long_name)
      );
      if (sProvincia) newProvinciaId = sProvincia.id;
    }

    if (comunaData) {
      const sComuna = comunas.find((c) =>
        includesIgnoreAccents(c.description, comunaData.long_name)
      );

      if (sComuna) {
        newComunaId = sComuna.id;
        const sBranch = sucursal.find((s) => sComuna.idBranch === s.id);
        if (sBranch) newSucursalId = sBranch.id;
      }
    }

    setCustomer((prevData) => ({
      ...prevData,
      address,
      idRegion: newRegionId,
      idProvince: newProvinciaId,
      idDistrito: newComunaId,
      idBranch: newSucursalId,
    }));
  };

  useEffect(() => {
    var lista = ["generos", "estadoCivil", "paises", "regiones", "provincias", "comunas", "sucursales",/*"negocios","tribunales","grupos","tribunalesext","metodosPago"*/]
    lista.forEach(option => {
      dispatch(setCargaGeneral(option));
    });
  }, []);

  if (!isLoaded) {
    return <div>Cargando...</div>;
  }

  return (
    <Paper elevation={6} sx={{ p: 4, mt: 4 }}>
      <ShowInformation from={from} />
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2} sx={{ mt: 2, p: 3 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              id="hubspotID"
              label="Hubspot ID"
              name="hubspotID"
              value={customer?.hubspotID || ""}
              onChange={handleChange}
              helperText={errors.hubspotID ?? ""}
              error={!!errors.hubspotID}
              disabled // se mantiene
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="Codigo de negocio Hubspot"
              name="dealHubspotId"
              required
              fullWidth
              value={customer.dealHubspotId || ""}
              onChange={handleChange}
              error={!!errors.dealHubspotId}
              helperText={errors.dealHubspotId ?? ""}
              disabled={bloqueadoTotalmente}
            >
              {dealHubspotIds.map((deal) => (
                <MenuItem key={deal.id} value={deal.id.toString()}>
                  {deal.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              disabled // se mantiene
              label="Rut"
              name="identifier"
              value={customer.identifier ?? ""}
              onChange={handleChange}
              helperText={errors.identifier ?? ""}
              error={!!errors.identifier}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              label="Nombre"
              name="firstName"
              value={customer.firstName ?? ""}
              onChange={handleChange}
              helperText={errors.firstName ?? ""}
              error={!!errors.firstName}
              disabled={bloqueadoTotalmente}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              label="Apellido"
              name="lastName"
              value={customer.lastName ?? ""}
              onChange={handleChange}
              helperText={errors.lastName ?? ""}
              error={!!errors.lastName}
              disabled={bloqueadoTotalmente}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Correo electrónico"
              type="email"
              name="email"
              required
              value={customer.email ?? ""}
              onChange={handleChange}
              helperText={errors.email ?? ""}
              error={!!errors.email}
              disabled={bloqueadoTotalmente}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Teléfono"
              type="tel"
              name="telephone"
              inputProps={{ maxLength: 12 }}
              value={customer.telephone ?? ""}
              onChange={handleChange}
              helperText={errors.telephone ?? ""}
              error={!!errors.telephone}
              disabled={bloqueadoTotalmente}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Fecha Nacimiento"
              type="date"
              name="birthDate"
              InputLabelProps={{ shrink: true }}
              required
              value={customer.birthDate}
              onChange={handleChange}
              helperText={errors.birthDate ?? ""}
              error={!!errors.birthDate}
              disabled={bloqueadoTotalmente}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="Género"
              name="idGenero"
              required
              fullWidth
              value={customer.idGenero ?? ""}
              onChange={handleChange}
              error={!!errors.idGenero}
              helperText={errors.idGenero ?? ""}
              disabled={bloqueadoTotalmente}
            >
              {genero.map((gen) => (
                <MenuItem key={gen.id} value={gen.id}>
                  {gen.description}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              select
              label="Estado Civil"
              name="idEstadoCivil"
              required
              value={
                customer.idEstadoCivil
                  ? Number(customer.idEstadoCivil)
                  : Number(0)
              }
              onChange={handleChange}
              error={!!errors.idEstadoCivil}
              helperText={errors.idEstadoCivil ?? ""}
              disabled={bloqueadoTotalmente}
            >
              {estadoCivil.map((est) => (
                <MenuItem key={est.id} value={Number(est.id)}>
                  {est.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={paises}
              getOptionLabel={(option) => option.description || ""}
              value={paises.find(p => p.id === (customer.idCountry == 0 ? 1 : customer.idCountry)) || null}
              onChange={(event, newValue) => {
                if (bloqueadoTotalmente) return;

                const value = newValue ? newValue.id : 1;
                setCustomer(prev => ({
                  ...prev,
                  idCountry: value
                }));

                handleError("idCountry", value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="País de Nacimiento"
                  required
                  error={!!errors.idCountry}
                  helperText={errors.idCountry ?? ""}
                />
              )}
              disabled={bloqueadoTotalmente}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <GoogleMapsAutocomplete
              onLoad={(autocompleteInstance) =>
                setAutocomplete(autocompleteInstance)
              }
              onPlaceChanged={handlePlaceChanged}
              options={{ componentRestrictions: { country: "cl" } }}
            >
              <TextField
                label="Dirección"
                fullWidth
                variant="outlined"
                value={customer.address ?? ""}
                onChange={handleChange}
                name="address"
                placeholder="Ingresa tu dirección"
                disabled={bloqueadoTotalmente || !allowUpdate}
                error={!!errors.address}
                helperText={errors.address ?? ""}
              />
            </GoogleMapsAutocomplete>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              select
              label="Región"
              name="idRegion"
              required
              value={customer.idRegion ?? ""}
              onChange={handleChange}
              error={!!errors.idRegion}
              helperText={errors.idRegion ?? ""}
              disabled={bloqueadoTotalmente}
            >
              {regiones.map((reg) => (
                <MenuItem key={reg.id} value={reg.id}>
                  {reg.description}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              select
              label="Provincia"
              name="idProvince"
              required
              value={customer.idProvince ?? ""}
              onChange={handleChange}
              error={!!errors.idProvince}
              helperText={errors.idProvince ?? ""}
              disabled={bloqueadoTotalmente}
            >
              {provincias.map((prov) => (
                <MenuItem key={prov.id} value={prov.id}>
                  {prov.description}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              select
              label="Comuna"
              name="idDistrito"
              required
              value={customer.idDistrito ?? ""}
              onChange={handleChange}
              error={!!errors.idDistrito}
              helperText={errors.idDistrito ?? ""}
              disabled={bloqueadoTotalmente}
            >
              {comunas.map((com) => (
                <MenuItem key={com.id} value={com.id}>
                  {com.description}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              select
              label="Sucursal"
              name="idBranch"
              required
              value={customer.idBranch ?? ""}
              onChange={handleChange}
              error={!!errors.idBranch}
              helperText={errors.idBranch ?? ""}
              disabled={bloqueadoTotalmente}
            >
              {sucursal.map((suc) => (
                <MenuItem key={suc.id} value={suc.id}>
                  {suc.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={Number(customer.clientType) === 2}
                  onChange={(e) =>
                    handleChange({
                      target: {
                        name: "clientType",
                        value: e.target.checked ? 2 : 1,
                      },
                    })
                  }
                  name="clientType"
                  color="primary"
                  disabled={bloqueadoTotalmente}
                />
              }
              label={
                customer.clientType === 2
                  ? "Cliente Jurídico"
                  : "Cliente Natural"
              }
            />
          </Grid>

          <Grid item xs={12} sm={6} />

          <Grid item xs={12} sm={6} hidden={customer.clientType !== 2}>
            <TextField
              fullWidth
              label="Rut Empresa"
              name="pymeRut"
              value={customer.pymeRut ?? ""}
              onChange={handleChange}
              helperText={errors.pymeRut ?? ""}
              error={!!errors.pymeRut}
              required={customer.clientType === 2}
              disabled={bloqueadoTotalmente}
            />
          </Grid>
          <Grid item xs={12} sm={6} hidden={customer.clientType !== 2}>
            <TextField
              fullWidth
              label="Nombre Empresa"
              name="pymeName"
              value={customer.pymeName ?? ""}
              onChange={handleChange}
              helperText={errors.pymeName ?? ""}
              error={!!errors.pymeName}
              required={customer.clientType === 2}
              disabled={bloqueadoTotalmente}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={customer.conClaveUnica}
                  onChange={(e) =>
                    handleChange({
                      target: {
                        name: "conClaveUnica",
                        value: e.target.checked,
                      },
                    })
                  }
                  name="conClaveUnica"
                  color="primary"
                  disabled={bloqueadoTotalmente}
                />
              }
              label={
                customer.conClaveUnica
                  ? "Quitar clave única"
                  : "Agregar clave única"
              }
            />
          </Grid>

          <Grid item xs={12} sm={6} />

          <Grid item xs={12} sm={6} hidden={!customer.conClaveUnica}>
            <TextField
              fullWidth
              label="Clave Única"
              name="claveUnica"
              value={customer.claveUnica ?? ""}
              onChange={handleChange}
              helperText={errors.claveUnica ?? ""}
              error={!!errors.claveUnica}
              required={customer.conClaveUnica}
              disabled={bloqueadoTotalmente}
            />
          </Grid>
          <Grid item xs={12} sm={6} hidden={!customer.conClaveUnica}>
            <TextField
              fullWidth
              label="Repetir Clave Única"
              name="claveUnicaB"
              value={customer.claveUnicaB ?? ""}
              onChange={handleChange}
              helperText={errors.claveUnicaB ?? ""}
              error={!!errors.claveUnicaB}
              required={customer.conClaveUnica}
              disabled={bloqueadoTotalmente}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Observaciones"
              type="textarea"
              name="observations"
              value={customer.observations ?? ""}
              onChange={handleChange}
              helperText={errors.observations ?? ""}
              multiline
              error={!!errors.observations}
              rows={3}
              disabled={bloqueadoTotalmente}
            />
          </Grid>

          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              {bloqueadoTotalmente ? (
                <Button
                  type="button"
                  variant="contained"
                  color="success"
                  startIcon={<SkipNext />}
                  size="large"
                  onClick={() => onChangeSave(1)}
                >
                  Continuar
                </Button>
              ) : (
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                >
                  Guardar y Continuar
                </Button>
              )}
            </Grid>

          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default Defendido;
